<template>
	<v-menu offset-y :open-on-hover="paymentStatus" :close-on-content-click="false">
		<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
			<v-btn
				block
				small
				depressed
				:dark="!paymentStatus"
				:style="btnStyle"
				class="d-flex align-center justify-center"
				style="pointer-events: auto !important; opacity: 1 !important; text-transform: none; letter-spacing: 0; justify-content: flex-start; padding: 0 10px;"
				v-bind="menuAttrs"
				v-on="menuOn"
			>
				<v-icon small left>{{ tooltipIcon }}</v-icon>
				<span class="caption font-weight-medium">{{ tooltipText }}</span>
			</v-btn>
		</template>

		<div class="pa-3 white" style="max-width: 400px; min-width: 350px;" v-if="!paymentStatus && isSubcontractor">
			<div class="d-flex align-center mb-1" style="gap: 8px;">
				<v-icon small color="grey darken-1">mdi-credit-card-outline</v-icon>
				<p class="subtitle-2 font-weight-bold mb-0">Sin pago registrado</p>
			</div>
			<v-divider class="my-2"></v-divider>
			<p class="caption mb-0 grey--text text--darken-1">No se han registrado pagos para esta cuota.</p>
			<p class="caption mb-0 grey--text text--darken-1">Cuando se realice un pago podrás ver el detalle aquí.</p>
		</div>

		<div class="pa-3 white" style="max-width: 400px; min-width: 350px;" v-else-if="!paymentStatus">
			<div class="d-flex align-center mb-1" style="gap: 8px;">
				<v-icon small style="color: #FF120B;">mdi-credit-card-outline</v-icon>
				<p class="subtitle-2 font-weight-bold mb-0">Iniciar nuevo pago</p>
			</div>
			<v-divider class="my-2"></v-divider>
			<p class="caption grey--text text--darken-1 mb-3">
				Selecciona la forma en que quieres realizar el pago: en línea o registrar manualmente.
			</p>
			<v-btn
				block
				small
				outlined
				style="text-transform: none; letter-spacing: 0; border-color: #FF120B; color: #FF120B;"
				class="mb-2"
				@click="openManualPaymentModal(payment)"
			>
				<v-icon small left style="color: #FF120B;">mdi-pencil-outline</v-icon>
				Registrar pago manualmente
			</v-btn>
			<v-btn
				block
				small
				depressed
				dark
				style="text-transform: none; letter-spacing: 0; background-color: #FF120B;"
				@click="startOnlinePayment(payment)"
			>
				<v-icon small left>mdi-credit-card-outline</v-icon>
				Iniciar pago en línea
			</v-btn>
		</div>

		<div class="pa-3 white" style="max-width: 300px; min-width: 250px;" v-else>
			<div class="d-flex align-center mb-1" style="gap: 8px;">
				<v-icon small color="green">mdi-check-circle</v-icon>
				<p class="subtitle-2 font-weight-bold mb-0 green--text text--darken-2">Cuota pagada</p>
			</div>
			<v-divider class="my-2"></v-divider>
			<div class="d-flex align-center justify-space-between mb-1">
				<p class="caption grey--text mb-0">Fecha de Pago</p>
				<p class="caption font-weight-bold mb-0">{{ paymentInfo?.payment_date | toDate }}</p>
			</div>
			<div class="d-flex align-center justify-space-between mb-1">
				<p class="caption grey--text mb-0">Monto Pagado</p>
				<p class="caption font-weight-bold mb-0">${{ paymentInfo?.amount | toThousandFilter }}</p>
			</div>
			<div class="d-flex align-center justify-space-between mb-1">
				<p class="caption grey--text mb-0">Forma de Pago</p>
				<p class="caption font-weight-bold mb-0">{{ paymentInfo?.method }}</p>
			</div>
		</div>
	</v-menu>
</template>

<script>
import { createPaymentOrder, startOrderPayment } from '@/helpers/api/general';

export default {
	name: 'StartPaymentSelection',
	props: {
		payment: {
			type: Object,
			required: true
		},
		clp_amount: {
			type: Number,
			required: true
		},
		uf_amount: {
			type: Number,
			required: true
		},
		color: {
			type: String,
			default: 'rgba(0, 0, 0, 0.87)'
		},
	},
	computed: {
		isSubcontractor(){
			return this.$store.state.user.companyPermissions?.subcontractor === true
		},
		btnStyle(){
			if(this.paymentStatus){
				return 'background-color: #2e7d32; pointer-events: auto !important; opacity: 1 !important; text-transform: none; letter-spacing: 0; justify-content: flex-start; padding: 0 10px;'
			}
			if(this.isSubcontractor){
				return 'background-color: #9E9E9E; pointer-events: auto !important; opacity: 1 !important; text-transform: none; letter-spacing: 0; justify-content: flex-start; padding: 0 10px;'
			}
			return 'background-color: #FF120B; pointer-events: auto !important; opacity: 1 !important; text-transform: none; letter-spacing: 0; justify-content: flex-start; padding: 0 10px;'
		},
		tooltipText(){
			if(this.paymentStatus){
				return 'Cuota Pagada'
			}
			else if(this.isSubcontractor){
				return 'Sin Pago Registrado'
			}
			return 'Nuevo Pago'
		},
		tooltipIcon(){
			return this.paymentStatus ? 'mdi-check-circle' : 'mdi-credit-card-outline'
		},
		paymentInfo(){
			if(this.payment.payment_order.length){
				const paidOrder = this.payment.payment_order.find(po => po.payment_info)
				if(paidOrder){
					return paidOrder.payment_info
				}
			}
			return null
		},
		paymentStatus(){
			if(this.payment.payment_order.length){
				if( this.payment.payment_order.some(po => po.payment_info) ){
					return true
				}
			}
			return false
		}
	},
	data() {
		return{}
	},
	methods: {
		openManualPaymentModal(payment){
			const orderData = {
				amount: Math.round(this.clp_amount),
				amount_uf: this.uf_amount,
				payer_id: this.$store.state.user?.userInfo?.id || null,
				concept: 'Pago Cuota A Subcontratista',
				item_id: payment.id,
				item_type: 'project_payment_et_payment',
				method: 'Transferencia',
				payment_date: new Date().toISOString().split('T')[0],
			}
			this.$store.commit('general/setManualPaymentOrderModal', {
				orderData,
				status: true
			})
		},
		async startOnlinePayment(payment){
			const orderData = {
				amount: Math.round(this.clp_amount),
				amount_uf: this.uf_amount,
				payer_id: this.$store.state.user?.userInfo?.id || null,
				concept: 'Pago Cuota A Subcontratista',
				item_id: payment.id,
				item_type: 'project_payment_et_payment',
				method: 'Transferencia',
				payment_date: new Date().toISOString().split('T')[0],
			}
			const payment_order = await createPaymentOrder(orderData)
			if(payment_order && payment_order.code == 200){
				const start_payment = await startOrderPayment({payment_order_id: payment_order.payment_order.id})
				if(start_payment && start_payment.code == 200){
					window.open(start_payment.redirect_url, '_blank')
					return
				}
			}
			this.setMessage({
				message: 'Hubo un error al iniciar el pago en línea. Por favor, intenta nuevamente.',
				title: 'Error al iniciar pago',
				type: 'error',
				icon: 'mdi-alert-circle-outline',
				color: 'red'
			})
		},
		setMessage(messageData){
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.dispatch('general/addMessage', data)
		},
	}
}
</script>

<style scoped>
.file-icon-buttons{
	width: 70px;
	height: 80px;
	border: 1px solid rgb(213, 211, 211);
	cursor: pointer;
}
.file-icon-buttons:hover{
	background-color: rgb(239, 239, 239);
}
.truncate-text {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100%;
}
</style>